import i18n from "@/plugins/vue-i18n";

const Updates = () => import("@/views/updates/index");

const UpdatesDetails = () => import("@/views/updates/details");

const updates = [
  {
    path: "/updates",
    name: "Updates",
    component: Updates,
    meta: {
      title: i18n.t("title.updates._"),
    },
  },
  {
    path: "/updates/:id",
    name: "UpdatesDetails",
    component: UpdatesDetails,
    meta: {
      title: i18n.t("title.updates.details"),
    },
  },
];

export default updates;
